
/* mac-chrome.js - nav toggle (pulldown desktop / drawer mobile) +
   scroll-synced vertical scrollbar thumb. Reads window.scrollY only;
   never creates a scroll container, so it can't break Dawn or mobile scroll. */
(function () {
  var frame = document.querySelector('[data-mac-frame]');
  if (!frame) return;

  var trigger = document.getElementById('MacNavTrigger');
  var menu    = document.getElementById('MacNav');
  var scrim   = document.getElementById('MacScrim');
  var vthumb  = document.getElementById('MacVThumb');
  var mqMobile = window.matchMedia('(max-width:749px)');

  function setOpen(open) {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    if (scrim) scrim.classList.toggle('is-open', open);
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = (open && mqMobile.matches) ? 'hidden' : '';
  }

  if (trigger) {
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      setOpen(!menu.classList.contains('is-open'));
    });
  }
  if (scrim) scrim.addEventListener('click', function () { setOpen(false); });
  if (menu) {
    menu.addEventListener('click', function (e) {
      e.stopPropagation();
      if (e.target.closest('a')) setOpen(false);
    });
  }
  document.addEventListener('click', function () { if (!mqMobile.matches) setOpen(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });

  function syncThumb() {
    if (!vthumb) return;
    var track = vthumb.parentElement;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    var frac = max > 0 ? window.scrollY / max : 0;
    var travel = Math.max(track.clientHeight - vthumb.offsetHeight - 2, 0);
    vthumb.style.top = (1 + frac * travel) + 'px';
  }
  window.addEventListener('scroll', syncThumb, { passive: true });
  window.addEventListener('resize', syncThumb);
  syncThumb();
})();
